



















































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyCheckAmountKey from "@/components/company-check-amout-key";
export default createComponent({
  setup(props,context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyCheckAmount = inject(CompanyCheckAmountKey);
    if (!companyCheckAmount) {
      throw new Error(`${CompanyCheckAmountKey} is not provided`);
    }
    const amountInfor = computed(() => companyCheckAmount.amountInfor);
    
    const paymentPreview =   () => {
      const showMonth = context.root.$route.query.show_month
      if(showMonth){
        companyCheckAmount.paymentPreview(showMonth)
      }else {
        companyCheckAmount.paymentPreview(new Date().toISOString().substr(0, 7))
      }
      
    }
    const getUserSettlement = () => {
      const showMonth = context.root.$route.query.show_month
       if(showMonth){
        companyCheckAmount.getUserSettlement(showMonth)
      }else {
        companyCheckAmount.getUserSettlement(new Date().toISOString().substr(0, 7))
      }
    }
    const firstPage = 1
    const formatNumber = (number: string) => displayui.formatNumber(number)
    return {
      amountInfor,
      paymentPreview,
      getUserSettlement,
      firstPage,
      formatNumber
    };
  },
})
